export enum ListingSearchType {
  Text = 'text',
  Date = 'date',
  DateRange = 'daterange',
  Enum = 'enum',
}

export interface ListingSearchFilter {
  value: string;
  viewValue: string;
  displayType: ListingSearchType;
  placeholder: string;
  options?: {
    value: any;
    viewValue: string;
  }[];
}
